var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-size"},[(_vm.tabName === 'Atualização de Beneficários')?_c('div',[_c('AtualizaoBeneficiario')],1):_vm._e(),(_vm.tabName === 'Gerenciamento de Token')?_c('div',[_c('GerenciamentoToken')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }